import { render, staticRenderFns } from "./userAgent.vue?vue&type=template&id=740ded9e"
import script from "./userAgent.vue?vue&type=script&lang=js"
export * from "./userAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports